/* unplugin-vue-components disabled */import { render } from "./approve.vue?vue&type=template&id=3e6c9754&scoped=true"
import script from "./approve.vue?vue&type=script&lang=js"
export * from "./approve.vue?vue&type=script&lang=js"

import "./approve.vue?vue&type=style&index=0&id=3e6c9754&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6c9754"]])

export default __exports__